export const toMmSs = (sec: number) => {
  return sec === 0 ? '00:00' : `${('00'+Math.floor(sec/60)).slice(-2)}:${('00'+(sec%60)).slice(-2)}`
}
